import { observer } from "mobx-react";
import React, { useState } from "react";
import { Dimensions, StyleSheet, Text, View } from "react-native";
import { Icon, Input } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import CustomHeader from "../../components/CustomHeader";
import ScreenImage from "../../components/ScreenImage";
import GradientButton from "../../components/GradientButton";
import signIn from "../../networking/api/auth/signIn";

const { width, height } = Dimensions.get("window");

const Login = observer(() => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [hidden, setHidden] = useState(true);
  return (
    <View style={styles.container}>
      <KeyboardAwareScrollView
        bounces={false}
        keyboardShouldPersistTaps="always"
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.contentContainerStyle}
        extraScrollHeight={height * 0.125}>
        <ScreenImage />
        <Text style={styles.loginText}>Login</Text>
        <View style={styles.inputView}>
          <Input
            placeholder="Email Address"
            value={email}
            autoCapitalize="none"
            onChangeText={(e) => setEmail(e)}
            keyboardType="email-address"
            inputStyle={styles.inputStyle}
            inputContainerStyle={styles.inputContainerStyle}
          />
          <Input
            placeholder="Password"
            value={password}
            onChangeText={(e) => setPassword(e)}
            secureTextEntry={hidden}
            rightIcon={
              <Icon
                name={hidden ? "eye" : "eye-with-line"}
                type="entypo"
                color="black"
                iconStyle={{ marginRight: 2.5 }}
                onPress={() => setHidden(!hidden)}
              />
            }
            inputStyle={styles.inputStyle}
            inputContainerStyle={styles.inputContainerStyle}
          />
        </View>
        <GradientButton text="Login" onPress={async () => await signIn(email, password)} />
      </KeyboardAwareScrollView>
    </View>
  );
});

export default Login;

const styles = StyleSheet.create({
  contentContainerStyle: {
    marginTop: height * 0.1,
    flexGrow: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  socialIconsView: {
    marginVertical: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  line: {
    width: width * 0.5,
    borderWidth: 1,
    borderColor: "gray",
    marginTop: height * 0.05,
  },
  inputView: { width: width * 0.5, alignItems: "center" },
  forgotPassword: {
    alignSelf: "flex-end",
    marginRight: 10,
    color: "#c7b077",
    fontFamily: "avenir",
  },
  loginText: {
    color: "gray",
    fontFamily: "avenir-h",
    marginVertical: 10,
    fontSize: RFValue(16),
  },
  inputStyle: {
    marginLeft: 10,
    fontSize: RFValue(14),
    fontFamily: "avenir",
    outlineWidth: 0,
  },
  inputContainerStyle: {
    height: height * 0.07,
    paddingVertical: 0,
    backgroundColor: "white",
    borderRadius: 5,
  },
  container: {
    flex: 1,
    backgroundColor: "#181d21",
    alignItems: "center",
    justifyContent: "center",
    minHeight: height,
  },
});
